import {
  getStyle
} from '@/config/mUtils'
const imgClipping = {
  directives: {
    'imgClipping': {
      bind: (el, binding) => {
        //获取高宽、没有就默认50*50
        var ratioString = binding.expression || "50*50";
        //取值
        var ratioArray = ratioString.split('*');
        // 获取高宽比例
        var ratio = parseFloat(ratioArray[0]) / parseFloat(ratioArray[1]);
        //获取是不是选择自适应
        var aspectFit = binding.modifiers.fit ? true : false;
        var src = el.src;
        if (src) {
          let img = new Image();
          img.src = el.src;
          img.onload = function () {
            //获取图片高宽比例
            var imgRatio = img.width / img.height;
            if (imgRatio > ratio && aspectFit || imgRatio < ratio && !aspectFit) {
              el.style.width = "100%";
            } else {
              el.style.height = "100%";
            }
          }
        }
      }
    }
  }
};
export {
  imgClipping,
}



// WEBPACK FOOTER //
// ./src/plugins/mixin.js